import React from 'react';
import { ImageBadge, Tile } from 'seduo-ui';
const Example = () => (<Tile title="Webinar" lector="Multiple, lector and lector" imageSrc="https://dummyimage.com/520x350/9fa4a8/fff.png" overlay={{
        bottomLeft: (<>
                    <ImageBadge text="2. 2. 2022"/>
                    <ImageBadge text="14:00"/>
                </>),
        topLeft: <ImageBadge icon="webinar" color="danger" text="Online Webináž" theme="dark"/>,
    }}/>);
export default Example;
